module.exports = __webpack_public_path__ + "img/logo_kronos.b040838b.png";